import { Popover } from 'module/ui/components/atoms/popover';
import styled from 'styled-components';
import { FolderTitleInput } from './input';

const Title = styled.div`
  cursor: pointer;
`;

interface Props {
  value: string;
  onChange: (value: string) => void;
  renderTitle?: (value: string) => React.ReactNode;
}

export const FolderTitle = ({ value, onChange, renderTitle }: Props) => {
  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      content={<FolderTitleInput value={value} onChange={onChange} />}
    >
      <Title>{renderTitle?.(value) ?? value}</Title>
    </Popover>
  );
};
